// extracted by mini-css-extract-plugin
export default {"name-table-cell":"CollaboratorTable_name-table-cell__ab2wK"};